<script setup>
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';

defineProps({
  keepAlive: {
    type: Boolean,
    default: true,
  },
});

const route = useRoute();
const { accountScopedRoute } = useAccount();

const gestaoTabs = [
  { key: 'general_settings_index', label: 'Categorias' },
  { key: 'settings_digital_humans_list', label: 'Agentes & Prompts' },
  { key: 'settings_inbox_list', label: 'Conexões' },
  { key: 'settings_procedures_list', label: 'Procedimentos' },
  { key: 'settings_procedure_scores_list', label: 'Protocolos / Score' },
  { key: 'agent_list', label: 'Equipe' },
  { key: 'settings_teams_list', label: 'Times' },
];

const gestaoRouteNames = new Set(gestaoTabs.map(t => t.key));

const isGestaoPage = computed(() => gestaoRouteNames.has(route.name));
</script>

<!-- eslint-disable vue/no-bare-strings-in-template, vue/no-static-inline-styles -->
<template>
  <div
    class="flex flex-col w-full h-full m-0 pb-8 pt-4 px-6 overflow-auto bg-n-surface-1"
  >
    <div
      v-if="isGestaoPage"
      style="max-width: 80rem; width: 100%; margin: 0 auto 24px"
    >
      <div class="clara-pill-tabs">
        <router-link
          v-for="tab in gestaoTabs"
          :key="tab.key"
          :to="accountScopedRoute(tab.key)"
          class="clara-pill-tab"
          :class="{ active: route.name === tab.key }"
          style="text-decoration: none"
        >
          {{ tab.label }}
        </router-link>
      </div>
    </div>
    <div class="flex items-start w-full max-w-5xl mx-auto">
      <router-view v-slot="{ Component }">
        <keep-alive v-if="keepAlive">
          <component :is="Component" :key="route.fullPath" />
        </keep-alive>
        <component :is="Component" v-else :key="route.fullPath" />
      </router-view>
    </div>
  </div>
</template>
